import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from './Header';
import Footer from '../../components/Footer/Footer';
import Join from '../../components/JoinModal/JoinModal';
import Modal from '../../components/Modal/Modal';

class Reliability extends Component {
  state = {
    modal: false
  }
  render() {
    const styles = require('./Reliability.less');

    return [
      <Helmet
        key="0"
        htmlAttributes={{ lang: 'ru-RU' }}
        title="Надежность данных онлайн сервиса для создания опросов и сбора отзывов (обратной связи) / оценок и аналитики от Клиентов (ЦА) – Mvoter.com"
        meta={[{ name: 'description', content: 'Надежность данных MVoter – Онлайн платформа для создания моментальной обратной связи с Клиентами! Онлайн сервис по сбору отзывов ✓ Анализ обратной связи от ЦА и потребителей ✓ Управление удовлетворенностью клиентов ✓ Отрасли использования опросника: Рестораны, Банки, Здравоохранение, Торговля, Общественный транспорт ☎ +7 (747) 359-5959' }]}
      />,
      <Header key="1" />,
      <div key="2" className={ styles.content }>
        <div className={ styles.inner }>
          <div className={ styles.wrap }>
            <h1>Надежность данных</h1>
            <div className={ styles.rowWrap }>
              <div className={ styles.rowItem }>
                <div className={ styles.leftSide }>
                  <img src="./images/reability/1.svg" width="410" height="301" />
                </div>
                <div className={ styles.rightSide }>
                  <p>Управленческие решения – должны опираться на достоверные и валидные данные. Бизнес который игнорирует это и принимает решения основываясь на искаженной и недостоверной информации терять свою конкурентоспособность.</p>
                  <p>Отзывы и информация получаемые из системы обратной связи с клиентами так же должны быть достоверными и валидными. Если система обратной связи с клиентами не гарантирует вам достоверность предоставляемых ею данных, то управленческие решения принимаемые на основе таких данных будут не просто неэффективными но могут нанести серьезный вред вашему бизнесу.</p>
                </div>
              </div>
              <div className={ styles.rowItem }>
                <div className={ styles.rightSide }>
                  <p>Не все существующие на рынке IT решения по обратной связи с клиентами могут гарантировать что собираемые ими отзывы (данные) являются достоверными, либо имеют возможность отсеивать фейковые и накрученные отзывы.</p>
                  <p>Соответственно с помощью таких систем обратной связи невозможно выстроить эффективную систему мотивации ваших сотрудников, а выводы и принимаемые решения по улучшению вашего сервиса или продукта могут быть неверными.</p>
                </div>
                <div className={ styles.leftSide }>
                  <img src="./images/reability/2.svg" width="410" height="301" />
                </div>
              </div>
              <div className={ styles.rowItem }>
                <div className={ styles.leftSide }>
                  <img src="./images/reability/3.svg" width="410" height="301" />
                </div>
                <div className={ styles.rightSide }>
                  <p>MVoter – это система обратной связи созданная профессиональными исследователями маркетологами и социологами. Мы понимаем важность надежности и валидности данных. Мы знаем как её обеспечить. Для этого мы обладаем необходимой методологической базой и цифровыми разработками внедренными в IT систему MVoter.</p>
                  <p>Мы гарантируем надежность и валидность данных предоставляемых системой MVoter!</p>
                </div>
              </div>
            </div>
            <h3>Создайте систему обратной связи сейчас. Это просто.</h3>
            <ul className={ styles.buttons }>
              <li><span onClick={ () => this.setState({ modal: true }) }>Регистрация</span></li>
              <li><span onClick={ () => this.setState({ modal: true }) }>Запросить демонстрацию</span></li>
            </ul>
          </div>
        </div>
        { this.state.modal
          && (
            <Modal
              title="Запросить демонстрацию"
              content={ <Join onCloseClick={ () => this.setState({ modal: false }) } /> }
              onCloseClick={ () => this.setState({ modal: false }) }
            />
          )}
      </div>,
      <Footer key="3" subId="page" />
    ];
  }
}

export default Reliability;
